import script from "./PostCardSnapImg.vue?vue&type=script&setup=true&lang=js"
export * from "./PostCardSnapImg.vue?vue&type=script&setup=true&lang=js"

import "./PostCardSnapImg.vue?vue&type=style&index=0&id=57384948&lang=scss"

const __exports__ = script;

export default __exports__